import React, { useState } from 'react'
import '../../assets/css/card.css'
import CardGenerator from '../../logic/CardGenerator'
import Navbar from '../Navbar/Navbar'
import Popup from '../Popup'
import {  
        clickGetCards, 
        checkComplete,
        firstClick, 
        secondClick,
        removeCardOldPlace,
        undoPlacement,
        getPrev,
        getHint,
        removeHighlight,
        undoDistribution,
        getCompleteHint,
        anyBlank,
        createLinked,
        setCardDisplay
        }
        from '../../logic/Gameplay'
import { cardsPush } from '../../logic/ComponentCreate'
import CardHolder from '../CardHolder/CardHolder'
import { Redirect } from 'react-router-dom'
import shuffleAudio from '../../assets/sound/shuffle.mp3'
import flickAudio from '../../assets/sound/flick.mp3'

const Game = () => {

    const {
        card_initial,
        card_rem
    } = CardGenerator()

    const [ allCards, setAllCards ] = useState(card_initial) // contains all cards 
    const [ highlighted, setHighlighted ] = useState({}) // keeps highlighted card, set when every first click to card
    const [ active, setActive ] = useState(false) // active means we have highlighted card so if any click triggered need to control for placement
    const [ request, setRequest ] = useState(0) // request keeps how many deck of cards will come from remaining cards
    const [ remCards, setRemCards ] = useState(card_rem) // remaining cards
    const [ complete, setComplete ] = useState(0) // complete keeps how many decks will completed
    const [ prevCards, setPrevCards ] = useState(null) // keep prev card for undo
    const [ canUndo, setCanUndo ] = useState(false) // undo control
    const [ undoDistribute, setUndoDistribute ] = useState(false) // undo after distribute new cards control
    const [ totalClick, setTotalClick ] = useState(0) // totalclick value for final score
    const [ time, setTime ] = useState(0) // hold time for display at final page
    const [ animatingCards, setAnimatingCards ] = useState(new Set()) // track cards being animated
    const [ popup, setPopup ] = useState({ show: false, message: '', type: 'info' });
    
    const handleTime = (time) => {
        setTime(time)
    }

    const animatedClickGetCards = (request, allCards, remCards) => {
        // Calculate positions for animation for each column
        const calculateAnimationForColumn = (columnIndex) => {
            const deckElement = document.querySelector('.cardholder');
            const columnElements = document.querySelectorAll('.cards-col');
            
            if (deckElement && columnElements[columnIndex]) {
                const deckRect = deckElement.getBoundingClientRect();
                const columnRect = columnElements[columnIndex].getBoundingClientRect();
                
                const deltaX = deckRect.left - columnRect.left;
                const deltaY = deckRect.top - columnRect.top;
                
                // Update CSS custom properties for this specific column
                document.documentElement.style.setProperty(`--deck-offset-x-${columnIndex}`, `${deltaX}px`);
                document.documentElement.style.setProperty(`--deck-offset-y-${columnIndex}`, `${deltaY}px`);
            }
        };
        
        // Pre-calculate all animation positions
        for (let index = 0; index < allCards.length; index++) {
            calculateAnimationForColumn(index);
        }
        
        // Store cards to be added with timing
        const cardsToAdd = [];
        for (let index = 0; index < allCards.length; index++) {
            cardsToAdd.push(remCards.shift());
        }
        
        // Add cards to columns with staggered timing
        cardsToAdd.forEach((cardData, index) => {
            setTimeout(() => {
                // Add the card to the game state at animation start time
                let element = allCards[index];
                if (element === null) {
                    // Create new card for empty column
                    element = createLinked(cardData)
                    allCards[index] = element
                } else {
                    // Find the last card in the column
                    while (element.next !== null) {
                        element = element.next
                    }
                    // Add new card to the end
                    element.next = createLinked(cardData)
                    element = element.next
                }
                
                // Mark this card as animating
                const cardId = element.val.value + " " + element.val.deck;
                setAnimatingCards(prev => new Set([...prev, `${cardId}-${index}`]));
                
                // Update display to show the new card
                setCardDisplay(allCards)
                setAllCards([...allCards]); // Force re-render
                
                // Remove animation class after animation completes
                setTimeout(() => {
                    setAnimatingCards(prev => {
                        const newSet = new Set(prev);
                        newSet.delete(`${cardId}-${index}`);
                        return newSet;
                    });
                }, 500); // Animation duration
                
            }, index * 100); // 100ms delay between each column
        });
        
        return {request: request + 1, remCards}
    }

    const showPopup = (message, type = 'info') => {
        setPopup({ show: true, message, type });
    };

    const hidePopup = () => {
        setPopup({ show: false, message: '', type: 'info' });
    };

    const clickHint = async () => {
        if (active) {
            if (getHint(allCards, highlighted)) {
                setTotalClick(totalClick + 3)
                setCanUndo(true)
                setUndoDistribute(false)
                CompleteControl()
            } else {
                showPopup("No Hint Found For This Card", "warning")
                removeHighlight(highlighted)
            }
            setActive(false)
        } else {
            let check = await getCompleteHint(allCards)
            check ? setTotalClick(totalClick + 5) : showPopup("No Hint Found", "warning")
        }
    }

    const clickUndo = () => {
        if (canUndo) {
            if (undoDistribute) {
                const prevRemCards = undoDistribution(allCards)
                setRemCards([...prevRemCards, ...remCards])
                setUndoDistribute(false)
            } else {
                removeCardOldPlace(prevCards.newHead, allCards)
                undoPlacement(allCards, prevCards)
                setPrevCards(null)
                setTotalClick(totalClick + 2)
            }
            setCanUndo(false)
        } else {
            showPopup("Please Click Rules for Undo Rules", "info")
            active && removeHighlight(highlighted)
            setActive(false)
        }
    }

    const clickRemCards = () => {
        if (anyBlank(allCards)) {
            new Audio(shuffleAudio).play()
            const {
                request: newRequest,
                remCards: newRemCards
            } = animatedClickGetCards(request, allCards, remCards)

            if (active) {
                setHighlighted({})
                removeHighlight(highlighted)
                setActive(false)
            }

            setRequest(newRequest)
            setRemCards(newRemCards)
            setCanUndo(true)
            setUndoDistribute(true)
            CompleteControl()
            setTotalClick(totalClick - 5)
        } else {
            showPopup("You must fill all columns for deal new cards", "warning")
        }
    }

    const clickCard = (item, index) => (e) => {
        if (!active) {
            if (firstClick(item)) {
                const newHead = firstClick(item)
                const prevShow = getPrev(allCards, newHead)
                setActive(true)
                setHighlighted(newHead) // highlight clicked card
                // set previous card information for undo
                setPrevCards({
                    index,
                    newHead,
                    removeIndex: null,
                    status: prevShow
                })
                setCanUndo(false)
            }
        } else {
            // set prevcards index for undo
            setPrevCards({
                ...prevCards,
                removeIndex: index
            })

            // if placement success set undo control
            if(secondClick(item, highlighted, allCards, index, showPopup)){
                setCanUndo(true)
                new Audio(flickAudio).play()
                setTotalClick(totalClick + 1)
            }

            // reset variables for new processes, check if any completed decks
            setActive(false)
            setHighlighted({})
            CompleteControl()
            setUndoDistribute(false)
        }
    }

    const CompleteControl = () => {
        const { complete: newComplete  } = checkComplete(allCards, complete, true, showPopup)
        newComplete !== complete && setCanUndo(false)
        setComplete(newComplete) // increase completed card value 
    }
    
    return (
        // wrap cards with column and inside the columns add new cards to get 4 * 6, 6 * 5 card matrix
        // call cardholder and navbar components
        // if all decks completed redirect to finish page with stats
        complete < 8 ?
        <div>
            {popup.show && (
                <Popup
                    message={popup.message}
                    type={popup.type}
                    onClose={hidePopup}
                />
            )}
            <Navbar clickUndo={clickUndo} clickHint={clickHint} complete={complete} handleTime={handleTime}/>

            <CardHolder clickRemCards={clickRemCards} remCards={remCards} complete={complete} />

            <div 
            className="cards">
                { allCards.map((card, index) => (
                        <div className="cards-col"> 
                            { cardsPush(card, index, clickCard, animatingCards) }
                        </div>
                    ))
                }
            </div>
        
        </div> : <Redirect to={{
            pathname: "/finish",
            state: { time: time,
                    click: totalClick }
        }} />
 
    )
}

export default Game